import styled from 'styled-components';

const ProgressCircle = styled.circle.withConfig({
    displayName: "ProgressRing.styles__ProgressCircle",
    componentId: "sc-b7db78f0-0"
})`
    transition-property: stroke-dashoffset;
    transition-duration: ${(props)=>props.animationDuration ?? 300}ms;
    transition-timing-function: linear;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
`;

export { ProgressCircle };
